import { get, post } from '../../../../util/api'
import { push } from 'connected-react-router'
import * as selector from './selector'
import * as type from './type'

export const findProspectRequest = (prospectId) => ({
    type: type.FIND_PROSPECT_REQUEST,
    payload: {
        prospectId,
    },
})

export const findProspectSuccess = (prospect) => ({
    type: type.FIND_PROSPECT_SUCCESS,
    payload: {
        prospect,
    },
})

export const findProspectError = (error) => ({
    type: type.FIND_PROSPECT_ERROR,
    payload: {
        error,
    },
})


export const findProspect = (prospectId) => (dispatch, getState) => {
    dispatch(findProspectRequest(prospectId))

    get('/api/prospect/find-by-id-full?prospectId=' + prospectId)
        .then(prospect => {
            dispatch(findProspectSuccess(prospect))
        })
        .catch(error => {
            dispatch(findProspectError(error))
        })
}

export const changeProspect = (name, value) => ({
    type: type.CHANGE_PROSPECT,
    payload: {
        name,
        value,
    },
})

export const saveProspectRequest = () => ({
    type: type.SAVE_PROSPECT_REQUEST,
    payload: {},
})

export const saveProspectSuccess = (prospect) => ({
    type: type.SAVE_PROSPECT_SUCCESS,
    payload: {
        prospect,
    },
})

export const saveProspectError = (error) => ({
    type: type.SAVE_PROSPECT_ERROR,
    payload: {
        error,
    },
})

export const saveProspect = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    if (!hasChanged) {
        return
    }

    const prospect = selector.selectProspect(state)

    dispatch(saveProspectRequest())

    post('/api/prospect/save', prospect)
        .then(prospect => {
            dispatch(saveProspectSuccess(prospect))
        })
        .catch(error => {
            dispatch(saveProspectError(error))
        })
}


export const archiveProspectRequest = () => ({
    type: type.ARCHIVE_PROSPECT_REQUEST,
    payload: {},
})

export const archiveProspectSuccess = (prospect) => ({
    type: type.ARCHIVE_PROSPECT_SUCCESS,
    payload: {
        prospect,
    },
})

export const archiveProspectError = (error) => ({
    type: type.ARCHIVE_PROSPECT_ERROR,
    payload: {
        error,
    },
})

export const archiveProspect = () => (dispatch, getState) => {
    const state = getState()

    const prospectId = selector.selectProspectId(state)

    dispatch(archiveProspectRequest())

    get('/api/prospect/archive?prospectId=' + prospectId)
        .then(prospect => {
            dispatch(archiveProspectSuccess(prospect))
        })
        .catch(error => {
            dispatch(archiveProspectError(error))
        })
}


export const noShowRequest = () => ({
    type: type.NO_SHOW_REQUEST,
    payload: {},
})

export const noShowSuccess = (prospect) => ({
    type: type.NO_SHOW_SUCCESS,
    payload: {
        prospect,
    },
})

export const noShowError = (error) => ({
    type: type.NO_SHOW_ERROR,
    payload: {
        error,
    },
})

export const noShow = () => (dispatch, getState) => {
    const state = getState()

    const prospectId = selector.selectProspectId(state)

    dispatch(noShowRequest())

    get('/api/prospect/no-show?prospectId=' + prospectId)
        .then(prospect => {
            dispatch(noShowSuccess(prospect))
        })
        .catch(error => {
            dispatch(noShowError(error))
        })
}


export const startInShopProcessRequest = () => ({
    type: type.START_IN_SHOP_PROCESS_REQUEST,
    payload: {},
})

export const startInShopProcessSuccess = (processTaskId) => ({
    type: type.START_IN_SHOP_PROCESS_SUCCESS,
    payload: {
        processTaskId,
    },
})

export const startInShopProcessError = (error) => ({
    type: type.START_IN_SHOP_PROCESS_ERROR,
    payload: {
        error,
    },
})

let startingInShopProcess = false

export const startInShopProcess = () => (dispatch, getState) => {
    const state = getState()
    const prospectId = selector.selectProspectId(state)
    if (!prospectId || startingInShopProcess) {
        return
    }
    startingInShopProcess = true

    dispatch(startInShopProcessRequest())

    get('/api/customer/start-in-shop-from-prospect?prospectId=' + prospectId)
        .then(({ processTaskId }) => {
            dispatch(startInShopProcessSuccess())
            dispatch(push('/task/detail/' + processTaskId))
            startingInShopProcess = false
        })
        .catch(error => {
            dispatch(startInShopProcessError(error))
            startingInShopProcess = false
        })
}



// WEBPACK FOOTER //
// ./src/modules/prospect/state/detail/action.js